var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanResourcesFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#ecc711;}.a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(79 228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82 193.525)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.01 47.083)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M399.886,273.32h-1.392a3.622,3.622,0,0,1,.219,1.245v5.261a1.551,1.551,0,0,1-.089.52h2.3a1.561,1.561,0,0,0,1.559-1.559v-2.868A2.6,2.6,0,0,0,399.886,273.32Z",
    transform: "translate(-398.494 -273.32)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 47.083)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.771,274.566a3.621,3.621,0,0,1,.219-1.245H2.6a2.6,2.6,0,0,0-2.6,2.6v2.868a1.561,1.561,0,0,0,1.559,1.559h2.3a1.552,1.552,0,0,1-.089-.52Z",
    transform: "translate(0 -273.321)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.81 45.73)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M142.61,234.815h-3.182a2.6,2.6,0,0,0-2.6,2.6v5.261a.52.52,0,0,0,.52.52h7.34a.52.52,0,0,0,.52-.52v-5.261A2.6,2.6,0,0,0,142.61,234.815Z",
    transform: "translate(-136.829 -234.815)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.875 38.84)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M170.239,38.84a3.124,3.124,0,1,0,3.125,3.125A3.128,3.128,0,0,0,170.239,38.84Z",
    transform: "translate(-167.114 -38.84)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.176 41.753)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.78,121.689a2.336,2.336,0,1,0,2.337,2.337A2.34,2.34,0,0,0,35.78,121.689Z",
    transform: "translate(-33.443 -121.689)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.15 41.753)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M347.944,121.689a2.337,2.337,0,1,0,2.337,2.337A2.34,2.34,0,0,0,347.944,121.689Z",
    transform: "translate(-345.607 -121.689)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanResourcesFill);
export default __webpack_public_path__ + "static/media/humanResourcesFill.d7672c98358b6a33914962cdab1b2183.svg";
export { ForwardRef as ReactComponent };